import FEATURES_CONFIG from 'config/features';
import useAction from 'hooks/useAction';
import { setPaymentMode } from 'pages/Checkout/redux/actions/payment.action';
import TrackerCheckout from 'utils/Tracker.checkout';
import EPaymentMethods from '../../PamentMethods.enum';
import usePayment from '../../hooks/usePayment';
import MobileWallet from '../MobileWallet';
import NewCardForm from '../NewCardForm';
import PaymentRadioCard from '../PaymentRadioCard';
import PaymentRadioCardHeader from '../PaymentRadioCardHeader';
import { useFeature } from '@mafc/appshell';
import { useMemo } from 'react';
import ICreditCard from '../../CreditCard.interface';

const { enableHostedCreditCard } = FEATURES_CONFIG.settings;

const PaymentMethodList: React.FC<{
  selectedPaymentMode: string;
}> = ({ selectedPaymentMode }) => {
  const {
    payment: {
      paymentDetails,
      creditCards: { list: creditCards },
    },
    isNewCard,
    isPaymentMethodAllowed,
  } = usePayment();

  const isCardOnDelivery = useFeature('card_on_delivery').on;
  const [setPaymentModeAction] = useAction(setPaymentMode);

  const cards = useMemo(() => {
    return creditCards.filter((card: ICreditCard) => !card.isExpired && card.isDefault);
  }, [creditCards]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    let clickedPaymentMode = e.target.value;

    TrackerCheckout.paymentMethodClicked(clickedPaymentMode);
    let paymentInfo = {};

    if (clickedPaymentMode === EPaymentMethods.SAVED_CARD && cards.length > 0) {
      paymentInfo = cards[0];
      clickedPaymentMode = EPaymentMethods.CREDIT_CARD;
    }

    setPaymentModeAction(clickedPaymentMode, { ...paymentInfo });
  };
  return (
    <>
      {/* Saved credit card list*/}
      {!enableHostedCreditCard &&
        cards.map((card: ICreditCard, index) => {
          return (
            <PaymentRadioCard
              value={EPaymentMethods.SAVED_CARD}
              checked={
                selectedPaymentMode === EPaymentMethods.CREDIT_CARD && paymentDetails.id === card.id
              }
              header={
                <PaymentRadioCardHeader
                  paymentMethod={EPaymentMethods.CREDIT_CARD}
                  cardData={card}
                />
              }
              onChange={onChangeHandler}
              disabled={card.isExpired}
              key={card.id}
              testid={`saved-credit-card-${index}`}
            />
          );
        })}

      {/* New credit card form*/}
      {isNewCard() && !enableHostedCreditCard && (
        <PaymentRadioCard
          value={EPaymentMethods.CREDIT_CARD}
          checked={selectedPaymentMode === EPaymentMethods.CREDIT_CARD && !paymentDetails.id}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.CREDIT_CARD} />}
          onChange={onChangeHandler}
          testid="new-card-form"
        >
          <NewCardForm
            paymentDetails={paymentDetails.newCardDetails || {}}
            saveCard={paymentDetails.savePaymentInfo}
            disabled={false}
          />
        </PaymentRadioCard>
      )}

      {isPaymentMethodAllowed(EPaymentMethods.CREDIT_CARD) && enableHostedCreditCard && (
        <PaymentRadioCard
          value={EPaymentMethods.CREDIT_CARD}
          checked={selectedPaymentMode === EPaymentMethods.CREDIT_CARD}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.CREDIT_CARD} />}
          onChange={onChangeHandler}
          testid="hosted-cc"
        />
      )}

      {isPaymentMethodAllowed(EPaymentMethods.DEBIT_CARD) && (
        <PaymentRadioCard
          value={EPaymentMethods.DEBIT_CARD}
          checked={selectedPaymentMode === EPaymentMethods.DEBIT_CARD}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.DEBIT_CARD} />}
          onChange={onChangeHandler}
          testid="hosted-dc"
        />
      )}

      {isPaymentMethodAllowed(EPaymentMethods.MOBILE_WALLET) && (
        <PaymentRadioCard
          value={EPaymentMethods.MOBILE_WALLET}
          checked={selectedPaymentMode === EPaymentMethods.MOBILE_WALLET}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.MOBILE_WALLET} />}
          onChange={onChangeHandler}
          testid="hosted-mobile-wallet"
        >
          <MobileWallet />
        </PaymentRadioCard>
      )}

      {isPaymentMethodAllowed(EPaymentMethods.COD) && (
        <PaymentRadioCard
          value={EPaymentMethods.COD}
          checked={selectedPaymentMode === EPaymentMethods.COD}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.COD} />}
          onChange={onChangeHandler}
          testid="cod"
        />
      )}

      {isCardOnDelivery && isPaymentMethodAllowed(EPaymentMethods.CARD_ON_DELIVERY) && (
        <PaymentRadioCard
          value={EPaymentMethods.CARD_ON_DELIVERY}
          checked={selectedPaymentMode === EPaymentMethods.CARD_ON_DELIVERY}
          header={<PaymentRadioCardHeader paymentMethod={EPaymentMethods.CARD_ON_DELIVERY} />}
          onChange={onChangeHandler}
          testid="cardondelivery"
        />
      )}
    </>
  );
};

export default PaymentMethodList;
